import { Link } from "react-router-dom";
import { FadeUp } from "./_shared";

const ECOSYSTEM = [
  { name: "Healthie", role: "Integration-First EHR" },
  { name: "Keragon", role: "Workflow Automation" },
  { name: "Notion", role: "Enterprise Workspace" },
  { name: "Jotform", role: "AI Agents & Intake" },
  { name: "Spruce Health", role: "HIPAA Communication" },
  { name: "Emergent", role: "AI Engineering" },
  { name: "Hugging Face", role: "AI Model Hosting" },
  { name: "Slack", role: "Clinical Ops Comms" },
  { name: "Salesforce", role: "Relationship Platform" },
  { name: "GitHub", role: "Source Control" },
];

export default function EcosystemStrip() {
  return (
    <section
      id="ecosystem"
      data-testid="ecosystem-strip-section"
      className="py-16 md:py-20 bg-card/60 border-y border-border"
    >
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <FadeUp className="text-center">
          <div className="iw-overline">Trusted Infrastructure</div>
          <h2 className="mt-4 font-display text-xl md:text-2xl font-bold tracking-tight text-primary">
            Built on a Connected Health Intelligence Ecosystem
          </h2>
        </FadeUp>

        <FadeUp delay={0.08} className="mt-10">
          <ul className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-px bg-border border border-border">
            {ECOSYSTEM.map((p) => (
              <li
                key={p.name}
                data-testid={`ecosystem-${p.name.toLowerCase().replace(/\s+/g, "-")}`}
                className="bg-background px-4 py-5 text-center"
              >
                <div className="font-display text-sm md:text-base font-bold text-primary">
                  {p.name}
                </div>
                <div className="mt-1 font-mono text-[0.52rem] uppercase tracking-[0.16em] text-foreground/50">
                  {p.role}
                </div>
              </li>
            ))}
          </ul>
        </FadeUp>

        <FadeUp delay={0.12} className="mt-8 text-center">
          <p className="font-mono text-[0.6rem] uppercase tracking-[0.2em] text-foreground/45">
            HIPAA-aware data handling · enterprise-grade security ·{" "}
            <Link
              to="/technology"
              data-testid="ecosystem-full-stack-link"
              className="text-accent hover:text-primary transition-colors font-semibold"
            >
              Explore the full stack →
            </Link>
          </p>
        </FadeUp>
      </div>
    </section>
  );
}
